import React from 'react';
import { MdClose, MdEmail, MdDomain, MdCalendarToday, MdVerified, MdReport, MdPictureAsPdf, MdPerson } from 'react-icons/md';
import './CustomerOffcanvas.css';

const CustomerOffcanvas = ({ show, onClose, customer }) => {
  if (!show || !customer) return null;

  return (
    <div className="customer-offcanvas-backdrop" onClick={onClose}>
      <div className="customer-offcanvas" onClick={(e) => e.stopPropagation()}>
        <div className="customer-offcanvas-header">
          <div className="header-content">
            <div className="customer-avatar">
              <MdPerson size={24} />
            </div>
            <div>
              <h4 className="customer-name">
                {`${customer.firstName || ''} ${customer.lastName || ''}`.trim() || 'N/A'}
              </h4>
              <p className="customer-email">{customer.email}</p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            <MdClose size={24} />
          </button>
        </div>

        <div className="customer-offcanvas-body">
          <div className="info-section">
            <h5 className="section-title">Basic Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdEmail size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Email Address</span>
                <span className="info-value">{customer.email || 'N/A'}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdDomain size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Domain</span>
                <span className="info-value">{customer.domain || 'N/A'}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Created Date</span>
                <span className="info-value">{customer.createdAt && !isNaN(new Date(customer.createdAt)) ? new Date(customer.createdAt).toLocaleDateString() : 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className="status-section">
            <h5 className="section-title">Status Information</h5>
            
            <div className="status-grid">
              <div className="status-card">
                <div className="status-icon verified">
                  <MdVerified size={20} />
                </div>
                <div className="status-content">
                  <span className="status-label">Email Verification</span>
                  <span className={`status-badge ${customer.verified ? 'verified' : 'unverified'}`}>
                    {customer.verified ? 'Verified' : 'Unverified'}
                  </span>
                </div>
              </div>

              {/* <div className="status-card">
                <div className="status-icon report">
                  <MdReport size={20} />
                </div>
                <div className="status-content">
                  <span className="status-label">Report Status</span>
                  <span className={`status-badge ${customer.reportSend ? 'sent' : 'pending'}`}>
                    {customer.reportSend ? 'Sent' : 'Pending'}
                  </span>
                </div>
              </div> */}
            </div>
          </div>

          {customer.summary && (
            <div className="summary-section">
              <h5 className="section-title">Summary</h5>
              <div className="summary-content">
                <p>{customer.summary}</p>
              </div>
            </div>
          )}

          {customer.pdfURL && (
            <div className="actions-section">
              <h5 className="section-title">Actions</h5>
              <a 
                href={customer.pdfURL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="pdf-btn"
              >
                <MdPictureAsPdf size={20} />
                <span>View Report PDF</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerOffcanvas;